module.exports = __webpack_public_path__ + "img/eight1Red.69dd3529.jpg";